import React from "react";
import { AccordionSet, Accordion, Checkbox, Button, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekTextField } from "./inputs";
import { LibraryTypeEnum } from "../types/Api";
export var LibraryFilters = function (_a) {
    var filters = _a.filters, onFilterChange = _a.onFilterChange, onTypeChange = _a.onTypeChange, onApplyFilters = _a.onApplyFilters, hasUnappliedChanges = _a.hasUnappliedChanges;
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.name",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-legaldeposits.filter.name", showLabel: false, value: filters.name, onChange: function (e) { return onFilterChange("name", e.target.value); }, placeholder: formatMessage({
                        id: "ui-br-legaldeposits.filter.name.placeholder",
                    }) })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.type",
                }), separator: false }, Object.values(LibraryTypeEnum).map(function (type) { return (React.createElement(Checkbox, { key: type, label: formatMessage({
                    id: "ui-br-legaldeposits.libraryType.".concat(type),
                }), checked: filters.types.includes(type), onChange: function () { return onTypeChange(type); } })); }))),
        React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, type: "submit", disabled: !hasUnappliedChanges },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.apply" }))));
};
